function parseStringArrayInput(input) {
  try {
    const raw = Array.isArray(input) ? input : JSON.parse(input || '[]');
    return Array.isArray(raw) ? raw.map((entry) => String(entry || '').trim()).filter(Boolean) : [];
  } catch {
    return [];
  }
}

function parseProductVariantsForStorefront(input) {
  try {
    const raw = Array.isArray(input) ? input : JSON.parse(input || '[]');
    if (!Array.isArray(raw)) return [];
    return raw
      .map((entry, index) => ({
        id: String(entry?.id || `variant_${index + 1}`).trim(),
        label: String(entry?.label || '').trim() || `Option ${index + 1}`,
        sku: String(entry?.sku || '').trim(),
        description: String(entry?.description || '').trim(),
        price: Math.max(0, Number(entry?.price ?? entry?.basePrice) || 0),
        orderPrice: Math.max(0, Number(entry?.orderPrice ?? entry?.price ?? entry?.basePrice) || 0),
        orderOriginalPrice: entry?.orderOriginalPrice ?? entry?.originalPrice ?? null,
        basePrice: Math.max(0, Number(entry?.basePrice ?? entry?.price) || 0),
        originalPrice: Number(entry?.originalPrice) > 0 ? Number(entry.originalPrice) : null,
        stock: Math.max(0, parseInt(entry?.stock, 10) || 0),
        active: entry?.active !== false && entry?.active !== 0 && entry?.active !== 'false',
        img: String(entry?.img || entry?.imageUrl || '').trim() || '',
        images: parseStringArrayInput(entry?.images),
      }))
      .filter((entry) => entry.id);
  } catch {
    return [];
  }
}

function normalizeStorefrontProduct(product) {
  const variants = parseProductVariantsForStorefront(product?.variants);
  const activeVariants = variants.filter((variant) => variant.active !== false);
  const galleryImages = parseStringArrayInput(product?.images);
  const hideBaseModel = [true, 1, 'true', '1'].includes(product?.hideBaseModel ?? product?.hide_base_model) && activeVariants.length > 0;
  const variantStock = activeVariants.reduce((sum, variant) => sum + variant.stock, 0);
  const baseStock = Math.max(0, Number(product?.baseStock ?? product?.base_stock ?? (activeVariants.length ? Number(product?.stock || 0) - variantStock : product?.stock)) || 0);
  const basePrice = Math.max(0, Number(product?.basePrice ?? product?.price) || 0);
  const baseDisplayPrice = Math.max(0, Number(product?.baseDisplayPrice ?? basePrice) || 0);
  const baseOriginalPrice = Number(product?.baseOriginalPrice) > baseDisplayPrice
    ? Number(product.baseOriginalPrice)
    : (Number(product?.originalPrice) > baseDisplayPrice && !activeVariants.length ? Number(product.originalPrice) : null);
  const displayCandidate = [
    ...(!hideBaseModel ? [{ price: baseDisplayPrice, originalPrice: baseOriginalPrice, img: String(product?.img || '').trim() || galleryImages[0] || '' }] : []),
    ...activeVariants
  ]
    .reduce((best, current) => (
      !best || Number(current.price) < Number(best.price) ? current : best
    ), null);
  return {
    ...product,
    img: String(product?.img || '').trim() || displayCandidate?.img || galleryImages[0] || '',
    images: galleryImages,
    variants,
    hideBaseModel,
    hasVariants: activeVariants.length > 0,
    optionResolved: activeVariants.length === 0,
    baseStock,
    basePrice,
    baseDisplayPrice,
    baseOriginalPrice,
    displayPrice: Number(displayCandidate?.price || 0),
    displayOriginalPrice: Number(displayCandidate?.originalPrice) > Number(displayCandidate?.price)
      ? Number(displayCandidate.originalPrice)
      : null,
    displayStock: (hideBaseModel ? 0 : baseStock) + variantStock,
    displayVariant: activeVariants.length > 0 && displayCandidate && activeVariants.some((variant) => variant.id === displayCandidate.id)
      ? displayCandidate
      : null
  };
}


export { parseStringArrayInput, normalizeStorefrontProduct };
